import { IField } from 'shared/entities/form';
import { IGraph } from 'shared/entities/graph';
import { IRootStore } from 'shared/entities/store/rootStore';
import { INewList } from 'shared/entities/list';
import { AIModelKind } from 'shared/entities/smartbotAI';

import {
  BlockBaseNormalized,
  BlockKind,
  BlockNormalizer,
  BlockType
} from '../common';

import {
  ConditionLlmClassificationServer,
  LlmClassificationClassServer
} from './server';

export interface ILlmClassificationClass {
  value: string;
}

export interface ILlmClassificationClassModel extends ILlmClassificationClass {
  readonly transition: IField<string | null>;
  readonly id: string;
  readonly valueField: IField<string>;

  readonly mainStore: IGraph;
  readonly rootStore: IRootStore;
  readonly blockId: string;
  readonly params: IConditionLlmClassificationParams;

  changeLink({ targetId }: { targetId: string | null }): void;
  getCopy(
    blockId: string,
    params: IConditionLlmClassificationParams
  ): ILlmClassificationClassModel;
  isEqual(other: ILlmClassificationClassModel): boolean;
  toJson(): LlmClassificationClassServer;
}

export interface IConditionLlmClassificationParams {
  gptModelType: IField<AIModelKind | null>;
  systemPrompt: IField<string>;
  classes: INewList<ILlmClassificationClassModel>;
}

export type ConditionLlmClassificationNormalized = BlockBaseNormalized<
  BlockType.condition,
  BlockKind.llmClassification
>;

export type ConditionLlmClassificationNormalizer = BlockNormalizer<
  ConditionLlmClassificationServer,
  ConditionLlmClassificationNormalized
>;

export const DEFAULT_SYSTEM_PROMPT =
  'Ты являешься классификатором пользовательских запросов.';

export const DEFAULT_LLM_GPT_MODEL_TYPE = AIModelKind.gpt5Nano;
